import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';

export default function App() {
  return (
    <>
      <Header />
      <div className="content">
        <div className="inner">
          <Outlet />
        </div>
      </div>
    </>
  );
}
